import { render, staticRenderFns } from "./DesinscricaoConfirmacao.vue?vue&type=template&id=c6e693ee&scoped=true"
import script from "./DesinscricaoConfirmacao.vue?vue&type=script&lang=js"
export * from "./DesinscricaoConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./DesinscricaoConfirmacao.vue?vue&type=style&index=0&id=c6e693ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e693ee",
  null
  
)

export default component.exports